import React, { useState } from 'react';
import Img from 'gatsby-image';
import { GiGemChain, GiWatch, GiDiamondRing, GiAbstract111, GiRolledCloth, GiCandleHolder } from 'react-icons/gi';
import { PiFlowerTulipFill } from 'react-icons/pi';
import { RiInkBottleFill } from 'react-icons/ri';
import { FaChildren } from "react-icons/fa6";
import { Box, useBreakpointValue } from '@chakra-ui/react';
import { findT } from '@interness/web-core/src/components/_helpers';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import routes from '@interness/web-core/config/routes';
import Logo from '@interness/web-core/src/components/media/Logo/Logo';
import Button from '@interness/web-core/src/components/elements/Button/Button';
import SEO from '@interness/web-core/src/components/modules/SEO/SEO';
import BrandsSubnavigation from '@interness/brands-addon/src/components/modules/BrandsSubnavigation/BrandsSubnavigation';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Heading from '@interness/web-core/src/components/text/Heading/Heading';
import RandomBrandHeaderImages from '@interness/brands-addon/src/components/media/RandomBrandHeaderImages/RandomBrandHeaderImages';
import * as S from './styles';
import CallToAction from '../../../../components/CallToAction/CallToAction';
import { jsx as ___EmotionJSX } from "@emotion/react";
const GridItem = _ref => {
  let {
    brand,
    lang
  } = _ref;
  let touched = false;
  const {
    0: hovering,
    1: setHovering
  } = useState(false);
  if (brand.gallery_images_square.length === 0) {
    console.log(brand.display_name);
  }
  return ___EmotionJSX(Link, {
    to: `${routes[brand.type.type][lang]}/${brand.slug}`,
    onTouchStart: () => touched = true,
    onMouseEnter: () => {
      if (!touched) {
        setHovering(true);
      }
    },
    onMouseLeave: () => {
      if (!touched) {
        setHovering(false);
      }
    }
  }, ___EmotionJSX(S.GridItem, {
    hovering: hovering
  }, ___EmotionJSX(S.BrandLogo, {
    visibility: hovering ? 'visible' : 'hidden'
  }, ___EmotionJSX(Logo, {
    logo: brand.logo.localFile,
    title: brand.display_name,
    svgFill: '#000',
    svgWidth: "240px",
    svgHeight: "80px"
  }), ___EmotionJSX(Button, null, "Mehr erfahren")), ___EmotionJSX(Img, {
    className: "background",
    fluid: brand.gallery_images_square[0].file.localFile.childImageSharp.fluid,
    alt: brand.display_name
  }), ___EmotionJSX(S.Overlay, null, ___EmotionJSX("h4", null, brand.display_name))));
};
const GridItemRolex = _ref2 => {
  let {
    brand,
    lang
  } = _ref2;
  if (brand.gallery_images_square.length === 0) {
    console.log(brand.display_name);
  }
  return ___EmotionJSX(Link, {
    to: `${routes[brand.type.type][lang]}/${brand.slug}`
  }, ___EmotionJSX(S.GridItem, null, ___EmotionJSX(Img, {
    className: "background",
    fluid: brand.gallery_images_square[0].file.localFile.childImageSharp.fluid,
    alt: brand.display_name
  })));
};
const BrandsPageTemplate = props => {
  const {
    type,
    lang
  } = props.pageContext;
  const brands = props.data.allDirectusBrands.nodes;
  const brandInfo = findT(props.data.directusBrandTypes.translations, lang);
  const showBanner = useBreakpointValue({
    base: 'none',
    sm: 'none',
    md: 'block',
    lg: 'block',
    xl: 'block',
    '2xl': 'block'
  }, {
    fallback: 'md'
  });
  const headings = {
    watches: {
      title: 'Feine Uhren',
      icon: ___EmotionJSX(GiWatch, null)
    },
    jewelry: {
      title: 'Erlesener Schmuck',
      icon: ___EmotionJSX(GiGemChain, null)
    },
    wedding_rings: {
      title: 'Trauringe',
      icon: ___EmotionJSX(GiDiamondRing, null)
    },
    engagement_rings: {
      title: 'Verlobungsringe',
      icon: ___EmotionJSX(GiDiamondRing, null)
    },
    accessories: {
      title: 'Accessories',
      icon: ___EmotionJSX(GiAbstract111, null)
    },
    home_fabrics: {
      title: 'Heimtextilien',
      icon: ___EmotionJSX(GiRolledCloth, null)
    },
    decoratives: {
      title: 'Dekoratives',
      icon: ___EmotionJSX(GiCandleHolder, null)
    },
    room_fragrances: {
      title: 'Raumdüfte',
      icon: ___EmotionJSX(RiInkBottleFill, null)
    },
    floral_workshop: {
      title: 'Florale Werkstatt',
      icon: ___EmotionJSX(PiFlowerTulipFill, null)
    },
    for_kids: {
      title: 'Für Kinder',
      icon: ___EmotionJSX(FaChildren, null)
    }
  };
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SEO, {
    title: brandInfo.display_name
  }), ___EmotionJSX(BrandsSubnavigation, {
    type: type
  }), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX(Wrapper, null, ___EmotionJSX(Heading, {
    icon: headings[type].icon,
    subtitle: `${findT(props.data.directusProject.translations, lang).seo_title}`
  }, headings[type].title), ___EmotionJSX(Spacer, {
    height: 20
  })), ___EmotionJSX(Box, {
    display: showBanner
  }, ___EmotionJSX(RandomBrandHeaderImages, {
    type: type
  })), ___EmotionJSX(Spacer, {
    height: 40
  }), ___EmotionJSX(Wrapper, null, ___EmotionJSX(S.Grid, null, brands.map(_ref3 => {
    let {
      brand
    } = _ref3;
    if (brand.slug === 'rolex') {
      return ___EmotionJSX(GridItemRolex, {
        brand: brand,
        key: `${brand.type.type}/${brand.display_name}`,
        lang: lang
      });
    } else {
      return ___EmotionJSX(GridItem, {
        brand: brand,
        key: `${brand.type.type}/${brand.display_name}`,
        lang: lang
      });
    }
  })), ___EmotionJSX(Spacer, null), ___EmotionJSX(CallToAction, null)));
};
const query = "2846313299";
export default BrandsPageTemplate;